var items = [ ];
items[ 'letters' ] = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z" ];
items[ 'numbers' ] = [ "0", "1", "2", "3", "4", "5", "6", "7", "8", "9" ];
var all_intervals = [ ];
var letters_count = 0;
var draw_slug;
var draw_views = $('#stage .winning-letter').length=== $('#stage .rotate').length ?false:true;
var draw_step_status = 0;
var current_step = 0;
var step_check = true;
var modal_check = true;
var draw_letters  = $('#stage .rotate').length>0?false:true;

var drawsOptions = {
    init: function( ) {
        var timeline = $( '#timeline' ).data( 'timeline' );
        var options = {
            seriesBarDistance: 12,
            distributeSeries: true,
            stretch: true,
            plugins: [
                Chartist.plugins.tooltip( )
            ],
            axisX: {
                showLabel: false,
                onlyInteger: false
            },
            axisY: {
                onlyInteger: true
            }
        };

        var responsiveOptions = [
            [ 'screen and (min-width: 640px)', {

            } ]
        ];



        var chart = new Chartist.Bar( '#timeline', timeline, options, responsiveOptions );


        chart.on( 'draw', function( data ) {
            if ( data.type == 'bar' ) {
                data.element.animate( {
                    y2: {
                        begin: 0,
                        dur: '0.5s',
                        from: data.y1,
                        to: data.y2
                    }
                } );
            }
        } );
    },
    open_codes_Modal: function( $link ) {
        $.ajax( {
            url: $link,
            success: function( data ) {
               
                $( '#modal' ).addClass('draw-animation-modal')
                $( '#modal' ).html( data.markup );
                $( 'body' ).addClass( 'dark-backdrop' );
                $( '#modal' ).modal( 'show' );


            },
            error: function( d ) {

            }
        } );
        return false;
    },
     open_draw_Modal: function( $link ) {
        $.ajax( {
            url: $link,
            success: function( data ) {
                modal_check = true;
                $( '#modal' ).addClass('draw-animation-modal')
                $( '#modal' ).html( data.markup );
                $( 'body' ).addClass( 'dark-backdrop' );
                $( '#modal' ).modal( 'show' ).on( 'hidden.bs.modal', function( ) {
                     modal_check = false;
                    $( '#modal' ).empty( );
                    $( 'body' ).removeClass( 'dark-backdrop' );
                    $('#draw_sound').remove();
                     clearAllIntervals( );
                    $( '#modal' ).removeClass( 'draw-animation-modal' );

                } );


            },
            error: function( d ) {

            }
        } );
        return false;
    }
};

var draw_dt = new Date( );
var drawSeconds = draw_dt.getSeconds( );
var lt_count = $('.winning-letter').length>0?$('.winning-letter').length:0;

var drawsDetais = {
    init: function( $url, $current_step ) {
        draw_slug = $url;
        current_step = $current_step;
        drawsDetais.getStatus( );    

         $.ajax( {
            type: "GET",
            url: '/draws/winning-letter',
            data: {
                slug: draw_slug
            },
            success: function( data ) {
                if( typeof data[ 'winning_letter' ]!=='undefined'){
                     var count = Object.keys( data[ 'winning_letter' ] ).length;
                    if ( count > 0 ) {
                         $( '#stage .rotate' ).each( function(index) {
                            if( typeof data[ 'winning_letter' ][ index ]!=='undefined' ){
                                $(this).addClass( 'pulse-stop winning-letter' );
                                $(this).find('.slot').html( '<p>' + data[ 'winning_letter' ][ index ] + '</p>' )
                            }
                            
                         } );
                     }
                }
               

            },
            error: function( d ) {
                setTimeout( function( ) {
                    //drawsDetais.init( draw_slug, current_step );
                }, 100 );
            }
        } );    

        
    },
    getCode: function( ) {       

         if($('#stage .winning-letter').length=== $('#stage .rotate').length ){
            return false;
         }

        $.ajax( {
            type: "GET",
            url: '/draws/winning-letter',
            data: {
                slug: draw_slug
            },
            success: function( data ) {
                var count = Object.keys( data[ 'winning_letter' ] ).length;
                 
                if ( count > 0 ) {
                   
                     $( '#stage .rotate' ).each( function(index) {
                        if( typeof data[ 'winning_letter' ][ index ]!=='undefined' ){
                            $(this).find('.slot').show();
                            $(this).addClass( 'pulse-stop winning-letter' );
                            $(this).find('.slot').html( '<p>' + data[ 'winning_letter' ][ index ] + '</p>' )
                        }
                        
                     });
                     

                    letters_count = Number( count - 1 );
                    if(lt_count<count ){
                        lt_count=count;
                        drawsDetais.randomNameShow( $( '#ring' + letters_count + ' .slot' ), data[ 'winning_letter' ][ letters_count ], 0 ); 
                    }
                   
                    if ( letters_count < data[ 'letters_number' ] ) {
                        setTimeout( function( ) {
                            drawsDetais.getCode( );
                        }, 1000 );
                    } else {
                        $('#draw_sound').remove();
                        draw_views = false;
                        clearAllIntervals();

                    }

                    if( count === data[ 'letters_number' ] ){
                        $('#draw_sound').remove();
                        draw_views = false;
                        clearAllIntervals();
                    }

                } else {
                    setTimeout( function( ) {
                        drawsDetais.getCode( );
                    }, 1000 );
                }
            },
            error: function( d ) {
                setTimeout( function( ) {
                    drawsDetais.getCode( );
                }, 1000 );
            }
        } );
    },
    getViews: function( $url ) {
        if($( '#terminal-cover' ).hasClass('final-step')){
            return false;
         }
            $.ajax( {
                type: "GET",
                url: '/draws/views',
                data: {
                    slug: $url
                },
                success: function( data ) {
                    if ( typeof( data.views ) !== 'undefined' ) {
                        $( '#draw-views' ).html( data.views );
                    }
                    setTimeout( function( ) {
                        drawsDetais.getViews( $url );
                    }, 10000 );
                },
                error: function( d ) {
                    setTimeout( function( ) {
                        drawsDetais.getViews( $url );
                    }, 10000 );
                }
            } );
        

    },
    getLetters: function( $url ) {
        if($('#stage .rotate').length ) {
            return false;
        }
            $.ajax( {
                type: "GET",
                url: '/draws/get_number_letters',
                data: {
                    slug: $url
                },
                success: function( data ) {
                    if ( typeof( data.letters_number ) !== 'undefined' ) {
                        $markup='';
                        for(var $i=0;$i<data.letters_number;$i++){
                            $markup+='<div class="rotate">\
                               <div id="ring'+$i+'" class="ring anim-pulse ring-animated-'+$i+'">\
                                    <div class="slot">\
                                        <p><svg version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 98.7 173.1" style="enable-background:new 0 0 98.7 173.1;" xml:space="preserve"><path d="M93.3,0c0.4,0.4,0.7,0.8,1.1,1.1c2,1.3,2.5,3.6,3.5,5.5C98,6.8,98.1,7,98.1,7.1c0.2,3.7,1,7.4,0.4,11 c-0.3,2.1-0.3,4.2-0.4,6.3c-0.1,0.8-0.4,1.5-0.5,2.3c-0.4,2.4-0.8,4.9-1.1,7.3c-0.2,1.5-0.6,3-1.2,4.5c-0.1,0.1-0.2,0.3-0.2,0.4 c0.3,2.2-0.8,4-1.3,6c-0.4,2-0.7,4-1.7,5.8c-0.1,2.9-1.8,5.3-2.1,8.1c-0.1,0.7-0.8,1.4-0.9,2.1c-0.8,3.8-2.4,7.3-3.6,11 c-0.6,2.1-1.7,3.9-2.4,6c-0.8,2.3-1.8,4.6-2.7,6.9c-1.2,2.9-2.7,5.7-4,8.6c-1.5,3.1-3.1,6.1-4.8,9c-1.3,2.1-2.7,4.3-4.3,6.3 c-1.2,1.4-2.3,2.8-3.6,4c-0.9,0.8-1.9,1.5-2.9,2.3c-1,0.2-2.2,0.3-3.4,0.6c-1.3,0.3-2.3-0.6-3.3-0.5c-2.7-1.3-2.9-4-4-6.2 c-0.1-0.1,0-0.3,0-0.5c0-3-0.2-6,0.1-9c0.1-1.7,0.5-3.4,1-5.1c0.6-1.9,0.8-3.8,1.4-5.7c0.8-2.4,1.2-4.8,1.8-7.2 c0.6-2.5,1.7-4.9,1.8-7.6c0-0.4,0.3-0.9,0.5-1.3c0.7-1.9,0.9-4,1.5-5.9c0.6-1.8,1.2-3.7,1.5-5.6c0.3-1.5,1.2-2.9,1.4-4.4 c0.1-1.5,0.8-2.9,1.2-4.3c0.3-1.3,0.8-2.7,1.4-3.9c0.6-1.2,0.5-2.8,1.1-4c0.6-1.3,0.9-2.6,1.4-3.9c1.3-3.5,2.4-7.1,3.9-10.6 c0.7-1.7,1.7-3.3,2.1-5.1c0.4-1.8,1.4-3.4,2.1-5.1c0.6-1.7,1.6-3.3,2.5-5c2.4-4.6,5.2-9,9.2-12.4C87.3,0.8,89-0.1,91.1,0 C91.9,0.1,92.6,0,93.3,0z M42.2,117.7c1.9-2.2,2.6-4.7,2.5-7.5c-0.1-2.3,0-4.7,0-7c-0.1-2.3-0.3-4.5-0.5-6.8c0-0.3-0.2-0.6-0.2-0.9 c-0.3-1.1-0.5-2.3-0.8-3.4c-0.3-1.3-0.2-2.6-0.6-3.8c-0.4-1.3-0.5-2.6-1.1-3.8c-0.5-1.2-0.6-2.6-1-3.9c-0.5-1.8-1.5-3.4-1.8-5.2 c-0.3-1.9-1.4-3.4-1.7-5.3c-0.2-0.9-0.4-1.8-0.9-2.6c-1.2-2.2-1.6-4.6-2.9-6.8c-0.6-1.1-1-2.4-1.5-3.6c-0.5-1.2-0.9-2.5-1.5-3.6 C28.3,49.1,26,45,23.5,41c-1.5-2.4-3-4.8-4.9-7c-1.9-2.3-4.1-4.4-6.8-5.9C10,27,8.1,26.7,6,27.4c-0.4,0.1-1,0.1-1.3,0.4 c-1.5,1.5-3.2,2.7-3.6,5c-0.1,0.7-0.8,1.4-0.9,2.1c-0.2,0.9-0.1,1.8,0,2.7c0.2,3.3-0.5,6.7,0.5,10c0.2,0.8,0.4,1.5,0.5,2.3 c0.2,0.8,0.3,1.7,0.5,2.5c0.3,1,0.8,2,0.9,3.1c0.2,1.5,0.6,2.9,1.1,4.3c0.5,1.5,1,3,1.3,4.4c0.3,1.2,1,2.3,1.3,3.5 C6.5,69,7,70.3,7.5,71.5c1.2,3.3,2.5,6.6,3.8,9.9c1.5,3.9,3.4,7.8,5.1,11.6c0.7,1.6,1.5,3.1,2.2,4.6c0.7,1.5,1.4,3.1,2.1,4.6 c1.2,2.8,2.8,5.5,4.2,8.3c1.4,3,3.9,5,6.3,7c1.3,1.1,2.8,2,4.3,3c1.1,0,2.3,0,3.3,0C40,119.6,41.8,119.5,42.2,117.7z M40.8,147.9 c1.5,0.3,3.3,0.5,4.8-0.4c1.4,0.4,2.7-0.4,4-0.5c1.1-0.1,2.3-0.3,3.3-0.6c4.5-1.4,8.8-3.1,13.1-5.1c1.3-0.6,2.5-1.6,3.8-2.3 c3.6-1.7,6.7-4.2,9.7-6.8c1.3-1.1,2.2-2.6,3.4-3.8c2.5-2.7,3.8-5.8,3.7-9.5c0-1-0.4-2-0.4-2.4c-1-1.2-1.7-1.9-2.5-2.8 c-1.7-0.1-3.4-0.2-5.2-0.3c-1.4-0.1-2.7,0.3-4,0.5c-1.1,0.2-2.2,0.4-3.2,0.7c-6.3,1.8-12.3,4.6-18.2,7.4c-3.6,1.7-7,3.6-10.6,5.5 c-0.1-0.1-0.3-0.2-0.5-0.4c-0.2-0.2-0.3-0.4-0.3-0.6c-0.2-2.3-1.2-4-3.4-5c-0.8,0-1.5,0.1-2.3,0c-1.7-0.2-3.2,0.3-4.6,1.1 c-2.4,1.3-4.9,2.6-6.8,4.7c-1,1-2,1.9-3.1,2.7c-3.1,2.1-5.5,5-8,7.7c-1,1-1.9,2.2-2.9,3.3c-1,1.1-1.9,2.2-2.8,3.3 c-1.1,1.3-2.3,2.6-3.3,3.9c-0.2,0.3-0.4,0.7-0.5,1c-0.7,1.7-1.5,3.4-2.1,5.1c-0.5,1.6-0.8,3.2-1.1,4.8c-0.3,1.1,0.3,2.1,0.5,3 c0.7,2.4,1.9,4.5,4.4,5.5c1.3,0,2.5,0.1,3.7,0c1.4-0.2,8.4-3.6,9.8-4.7c2.7-2.1,5.5-4.2,8-6.6c2.2-2.1,4.2-4.4,6.2-6.7 c0.8-0.9,1.4-2,2.2-3.1c0.6,0.3,1.2,0.6,2.1,1.1C38.6,147.6,39.7,147.7,40.8,147.9z M45.5,173c0.8,0.1,1.7,0.1,2.5,0 c0.9-0.1,1.7-0.5,2.5-0.4c1.5,0.2,3-0.3,4.3-0.7c1.6-0.5,3.3-0.9,4.9-1.3c1.7-0.4,3.2-1.1,4.8-1.6c1.9-0.6,3.7-1.5,5.6-2.3 c2.2-1,4.2-2.4,6.3-3.6c2-1.2,3.9-2.4,5.7-3.8c1.9-1.5,3.6-3.1,5.1-5.1c3.3-4.3,3.6-6.1,3.4-10.4c-0.1-1.8-1.7-3.9-3.3-4.2 c-1.3-0.3-2.7-0.4-4-0.5c-1.1-0.1-2.3-0.2-3.3,0.5c-2.1-0.3-4,1.1-6.1,1c-2.5,1.3-5.3,1.7-7.8,2.8c-2.5,1.1-5.1,2.1-7.7,3.2 c-3.1,1.3-6,3.1-9.1,4.5c-3.2,1.5-5.9,3.6-8.2,6.2c-0.6,0.7-1,1.4-1.6,2.1c-1.7,1.8-2.2,4.1-2.8,6.3c-0.2,0.8-0.1,1.6,0.5,2.3 c0.3,0.5,0.5,1.1,0.9,2.2c0.8,0.6,2,1.4,3,2.1C42.8,172.6,44.2,172.9,45.5,173z"/></svg></p>\
                                    </div>\
                               </div>\
                           </div>';
                        }

                    
                        $( '#stage' ).html( $markup );

                        draw_letters =false;
                    }else{
                        setTimeout( function( ) {
                            drawsDetais.getLetters( $url );
                        }, 5000 );
                    }
                    
                },
                error: function( d ) {
                    setTimeout( function( ) {
                        drawsDetais.getLetters( $url );
                    }, 5000 );
                }
            } );
       
        

    },
    replayDraw: function( $_slug, $_counter ) {
         if(modal_check){
   
               var replaycounter = $_counter;
       
                $.ajax( {
                    type: "GET",
                    url: '/draws/review-draw',
                    data: {
                        slug: $_slug
                    },
                    success: function( data ) {

                        if ( typeof( data ) !== 'undefined' ) {
                                var $status_label = $( '#info-status' ).html( );
                                if ( typeof( data['steps'][replaycounter ] ) !== 'undefined' ) {
                                    $( '#info-status' ).html( '<span class="info-status-step info-status-step-' + replaycounter + '">' + data['steps'][replaycounter ] + '</span>' );
                                }

                                if ( $status_label !== '' ) {
                                    $( '#terminal-cover' ).append( '<p>' + $status_label + '</p>' );
                                }

                                if ( replaycounter === 1 ) {
                                    var counter = 1;
                                    var counter_interval = setInterval( function( ) {
                                        if ( counter > 0 && counter < 10 ) {
                                            $( "#info-status span.info-status-step" ).append( '.' );
                                        } else {
                                            $( "#info-status span.info-status-step" ).append( ' done' );
                                            clearInterval( counter_interval );
                                            replaycounter++;
                                            setTimeout(function(){drawsDetais.replayDraw($_slug,replaycounter); },1000);
                                        }
                                        counter += 1;
                                    }, 500 );

                                    all_intervals.push(counter_interval);

                                } else if ( replaycounter === 3 ) {
                                    var letter_counter = 1;
                                    drawsDetais.randomNameHide( );
                                    var letter_interval = setInterval( function( ) {
                                        if ( letter_counter > 0 && letter_counter <= data[ 'letters_number' ] ) {
                                            drawsDetais.randomNameShow( $( '#ring' + Number( letter_counter - 1 ) + ' .slot' ), data[ 'winning_letter' ][ Number( letter_counter - 1 ) ], 0 );
                                            if(letter_counter=== data[ 'letters_number' ]){
                                               $( '.draw-sounds' ).remove();
                                            }
                                        } else {
                                            $('#draw_sound').remove();
                                            clearInterval( letter_interval );
                                           
                                            replaycounter++;
                                            setTimeout(function(){drawsDetais.replayDraw($_slug,replaycounter); },100);
                                        }
                                        letter_counter += 1;
                                    }, 3000 );
                                    all_intervals.push(letter_interval);
                                } else if(replaycounter === 0) {
                                    setTimeout( function( ) {
                                       replaycounter++;
                                       drawsDetais.replayDraw($_slug,replaycounter);
                                    }, 3000 );
                                }else if(replaycounter === 2 || replaycounter === 4) {
                                    setTimeout( function( ) {
                                       replaycounter++;
                                       drawsDetais.replayDraw($_slug,replaycounter);
                                    }, 2000 );
                                }else if(replaycounter === 5) {
                                      $('#play_final_sound').trigger('click');
                                }
                            
                        }

                    },
                    error: function( d ) {
                        setTimeout( function( ) {
                            drawsDetais.replayDraw( $_slug );
                        }, 1000 );
                    }
                } );


         }

    },
    getStatus: function( ) {

         if($( '#terminal-cover' ).hasClass('final-step')){
            return false;
         }

        $.ajax( {
            type: "GET",
            url: '/draws/status',
            data: {
                slug: draw_slug
            },
            success: function( data ) {
                var count = Object.keys( data ).length;
                var draw_step_status = Number( count - 1 );
                 var $status_label = $( '#info-status' ).html( );

                if ( count === 6 || current_step === count ) {
                    step_check = false;
                    if ( count === 6 ) {
                        
                        if(!$( '#terminal-cover' ).hasClass('final-step') ){
                                if($("#draw_finish").length>0){
                                     $('#play_final_sound').trigger('click');
                                }
                              $( '#terminal-cover' ).append( '<p>' + $status_label + '</p>' );
                              $( '#terminal-cover' ).addClass('final-step');
                        }
                      


                        if ( typeof( data[ 'step' + draw_step_status ] ) !== 'undefined' ) {
                            $( '#info-status' ).html( '<span class="info-status-step info-status-step-' + draw_step_status + '">' + data[ 'step' + draw_step_status ] + '</span>' );
                        }
                    }
                } else if ( current_step < count && typeof( data ) !== 'undefined' ) {
                    step_check = true;
                }
                if ( step_check && typeof( data ) !== 'undefined' ) {

                    if ( typeof( data[ 'step' + draw_step_status ] ) !== 'undefined' ) {
                        $( '#info-status' ).html( '<span class="info-status-step info-status-step-' + draw_step_status + '">' + data[ 'step' + draw_step_status ] + '</span>' );
                    }

                    if ( $status_label !== '' && current_step < count ) {
                        $( '#terminal-cover' ).append( '<p>' + $status_label + '</p>' );
                    }

                    current_step = count;

                    if ( draw_step_status === 1 ) {
                        var counter = 1;
                        var counter_interval = setInterval( function( ) {
                            if ( counter > 0 && counter < 10 ) {
                                $( "#info-status span.info-status-step" ).append( '.' );
                            } else {
                                $( "#info-status span.info-status-step" ).append( ' done' );
                                clearInterval( counter_interval );
                            }
                            counter += 1;
                        }, 500 );
                         all_intervals.push(counter_interval);
                    } else if ( draw_step_status === 3 ) {                        
                        drawsDetais.randomNameHide( );
                        setTimeout( function( ) {
                            drawsDetais.getCode( );
                        }, 1000 );
                    }

                }

                setTimeout( function( ) {
                    drawsDetais.getStatus( );
                }, 1000 );

            },
            error: function( d ) {
                setTimeout( function( ) {
                    drawsDetais.getStatus( );
                }, 1000 );
            }
        } );
    },
    randomNameHide: function( ) {
        clearAllIntervals( );
        $( 'body' ).append( '<iframe class="draw-sounds" id="draw_sound" src="/assets/frontend/media/draw.mp3" allow="autoplay;" style="display:none"></iframe>' );
        var slots = items[ 'letters' ];

        $( '.draw .rotate' ).each( function( index ) {

            var $rotate = $( this );

            $rotate.addClass( 'pulse-stop' );
            var $this = $rotate.find( '.slot' );
            var timeout = 0;
            var win_timeout = 10;

            timeout = setInterval( function( ) {
                if ( !$rotate.hasClass( 'winning-letter' ) ) {
                    var random = parseInt( Math.random( ) * slots.length );
                    var randomName = slots[ random ];
                    $this.html( '<p ' + index + '> ' + randomName + '</p' );
                }
            }, win_timeout );
             all_intervals.push(timeout);
        } );

    },
    randomNameShow: function( target, letter, intv ) {
        target.show( );
        $('#play_sound').trigger('click');
        timeout = setInterval( function( ) {
            target.parent().parent( ).addClass( 'winning-letter' );
            target.html( '<p>' + letter + '</p' );
        }, intv );


    }

};

function clearAllIntervals( ) {
    jQuery.each( all_intervals, function( i, val ) {
        window.clearInterval( val );
    } );
    all_intervals = [ ];
}

function playAudio($tt) { 
  var target = $($tt).data('target');
  var x = document.getElementById(target); 
  x.play(); 
} 
